<div class="size-full">
  @if (appComponentInitializing$ | async) {
    <app-loading-screen></app-loading-screen>
  }

  <app-navigator></app-navigator>
</div>
